import * as ReferralIDL from "./idl/referral.json";

function getAccountDiscriminator(name: string): Buffer {
  const account = ReferralIDL.accounts.find((a) => a.name === name);
  if (!account) {
    throw new Error(`Account ${name} not found in IDL`);
  }
  return Buffer.from(account.discriminator);
}

export const ESCROW_DISCRIMINATOR = getAccountDiscriminator("Escrow");
export const STAKING_DISCRIMINATOR = getAccountDiscriminator("Staking");
export const UNSTAKE_DISCRIMINATOR = getAccountDiscriminator("Unstake");
